<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import type { ProductCategoryProps } from "./ProductCategoryProps.js";
	import ProductCard from "../components/Product/ProductCard.svelte";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import ProductCategoryFilters from "../components/ProductCategoryFilters.svelte";
	import Branches from "../components/Branches.svelte";
	import WeddingsBanner from "../components/Wedding/WeddingsBanner.svelte";
	import Content from "../components/Content.svelte";
	import { setContext } from "svelte";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";
	import { PriorityLabel } from "../../../core/schema/PriorityLabel.js";

	type $$Props = ProductCategoryProps;

	const { products, category } = $$restProps as $$Props;
	const { TENANT_LOCALE, STORAGE_URL } = getGlobalSettings();

	const [thumbnailProduct] = products.toSorted((first, second) => {
		if (first.priorityLabel === PriorityLabel.Favorite) {
			return first.priorityLabel === second.priorityLabel ? 0 : -1;
		}
		return 0;
	});
	if (thumbnailProduct) {
		setContext(thumbnailImageContextKey, `${STORAGE_URL}/${thumbnailProduct.images[0]?.path}`);
	}

	const filters = Array.from(new Set(products.flatMap(({ filtrationLabels }) => filtrationLabels[TENANT_LOCALE])));
	let selectedFilters: string[] = [];

	$: filteredProducts = products.filter((product) => {
		if (selectedFilters.length === 0) {
			return true;
		}
		return selectedFilters.some((filter) => product.filtrationLabels[TENANT_LOCALE].includes(filter));
	});
</script>

<Layout>
	<div class="container">
		<section>
			<h1
				class="mb-8 mt-5 p-0 text-center text-[2rem] font-semibold leading-10 lg:mb-[1.625rem] lg:mt-0 lg:text-xl lg:leading-[3.25rem]"
			>
				{nbspify(category.name[TENANT_LOCALE])}
			</h1>
			<div class="mx-auto my-4 max-w-[700px] text-base">
				<Content content={category.description[TENANT_LOCALE]} />
			</div>
			{#if filters.length > 0}
				<ProductCategoryFilters {filters} bind:selectedFilters />
			{/if}

			<div class="product-card-wrapper">
				{#each filteredProducts as product, index (product.id)}
					<ProductCard {product} {index} />
				{/each}
			</div>
		</section>

		<section>
			<WeddingsBanner />
		</section>

		<section>
			<Branches />
		</section>
	</div>
</Layout>
